import { createContext, useContext, useReducer } from "react";
import roiReducer, { initialState } from "./roiReducer";

const RoiContext = createContext(initialState);

export const RoiProvider = ({ children }) => {
  const [state, dispatch] = useReducer(roiReducer, initialState);

  const updateProvider = (value) => {
    dispatch({
      type: "UPDATE_NO_OF_PROVIDERS",
      payload: {
        numberOfProviders: value,
      },
    });
  };
  const updateMonthlyAppointments = (value) => {
    dispatch({
      type: "UPDATE_MONTHLY_APPOINTMENTS",
      payload: {
        monthlyAppointments: value,
      },
    });
  };
  const updateNewPatientVisits = (value) => {
    dispatch({
      type: "UPDATE_NEW_PATIENT_VISITS_PER_MONTH",
      payload: {
        percentageOfNewPatientsVisitMonth: value,
      },
    });
  };
  const updatePatietnTicketSize = (value) => {
    dispatch({
      type: "UPDATE_PATIENT_TICKET_SIZE",
      payload: {
        averageOrderValueEachPatientPerVisitOrPatientTicketSize: value,
      },
    });
  };
  const updateDigitalIntakeDependency = (value) => {
    dispatch({
      type: "UPDATE_PAPER_BASED_DEPENDENCY",
      payload: {
        paperBasedIntakeDependency: value,
      },
    });
  };

  const updateStaffData = (data) => {
    dispatch({
      type: "UPDATE_STAFF_DATA",
      payload: {
        staffData: data,
      },
    });
  };

  const updateNoShowData = (data) => {
    dispatch({
      type: "UPDATE_NO_SHOW_DATA",
      payload: {
        noShowData: data,
      },
    });
  };

  const updatePaymentCollectionData = (data) => {
    dispatch({
      type: "UPDATE_PAYMENT_COLLECTION_DATA",
      payload: {
        paymentCollectionData: data,
      },
    });
  };

  const updateAutomatedSavingsData = (data) => {
    dispatch({
      type: "UPDATE_AUTOMATED_SAVINGS_DATA",
      payload: {
        automatedSavings: data,
      },
    });
  };

  const updatePaymentCollectionInputValue = (data) => {
    dispatch({
      type: "UPDATE_PAYMENT_COLLECTION_INPUT_VALUE",
      payload: {
        paymentCollectionInputValue: data,
      },
    });
  };

  const updateNoShowInputValue = (data) => {
    dispatch({
      type: "UPDATE_NO_SHOW_INPUT_VALUE",
      payload: {
        reduceNoShowInputValue: data,
      },
    });
  };

  const updateSaveStaffHoursInputValues = (data) => {
    dispatch({
      type: "UPDATE_SAVE_STAFF_HOURS_INPUT_VALUE",
      payload: {
        saveStaffHoursInputValues: data,
      },
    });
  };

  const updateCostGoingPaperLess = (data) => {
    dispatch({
      type: "UPDATE_COST_GOING_PAPER_LESS",
      payload: {
        costGoingPaperless: data,
      },
    });
  };

  const value = {
    numberOfProviders: state.numberOfProviders,
    monthlyAppointments: state.monthlyAppointments,
    percentageOfNewPatientsVisitMonth: state.percentageOfNewPatientsVisitMonth,
    averageOrderValueEachPatientPerVisitOrPatientTicketSize:
      state.averageOrderValueEachPatientPerVisitOrPatientTicketSize,
    paperBasedIntakeDependency: state.paperBasedIntakeDependency,
    staffData: state.staffData,
    noShowData: state.noShowData,
    paymentCollectionData: state.paymentCollectionData,
    automatedSavings: state.automatedSavings,
    paymentCollectionInputValue: state.paymentCollectionInputValue,
    reduceNoShowInputValue: state.reduceNoShowInputValue,
    saveStaffHoursInputValues: state.saveStaffHoursInputValues,
    costGoingPaperless: state.costGoingPaperless,
    updateProvider,
    updateMonthlyAppointments,
    updateNewPatientVisits,
    updatePatietnTicketSize,
    updateDigitalIntakeDependency,
    updateStaffData,
    updateNoShowData,
    updatePaymentCollectionData,
    updateAutomatedSavingsData,
    updatePaymentCollectionInputValue,
    updateNoShowInputValue,
    updateSaveStaffHoursInputValues,
    updateCostGoingPaperLess,
  };
  return <RoiContext.Provider value={value}>{children}</RoiContext.Provider>;
};

const useRoi = () => {
  const context = useContext(RoiContext);

  if (context === undefined) {
    throw new Error("useRoi must be used within ShopContext");
  }

  return context;
};

export default useRoi;
